<template>
  <div class="px-3 text-center md:px-10">
    <div
      class="progress-container relative inset-y-0 flex items-center justify-between"
    >
      <div class="progress" :style="progressStyle"></div>
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="circle"
        :class="colorStep(step)"
      >
        <span
          class="text-ontick-carbon-500"
          v-if="step.success"
          v-html="$icons.check"
        ></span>
        <span v-if="step.active" v-html="$icons.loading"></span>
        <span v-if="step.error" v-html="$icons.closex"></span>
      </div>
    </div>
    <div class="flex items-center justify-center py-5">
      <div v-if="!error">
        <p
          v-for="item in steps.filter((item) => item.active)"
          :key="item.active"
          class="text-gray-300"
        >
          {{ item.label }}
        </p>
        <p
          v-show="!steps[2].active & steps[2].success"
          class="text-gray-300"
          :key="4"
        >
          Inicialização concluída
        </p>
      </div>
      <div class="flex items-center space-x-4" v-else>
        <p class="font-medium text-ontick-red-500">
          {{ error_msg }}
        </p>
        <a
          @click="redirectHistoric()"
          class="cursor-pointer border-b border-gray-400 text-sm font-medium text-gray-400"
        >
          Verificar logs
        </a>
      </div>
    </div>
    <!-- <button class="btn" @click="prev" :disabled="prevDisabled">Prev</button>
    <button class="btn" @click="next" :disabled="nextDisabled">Next</button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      steps: [
        {
          label: "Preparando ambiente",
          active: true,
          success: false,
          error: false,
        },
        {
          label: "Conectando com servidor",
          active: false,
          success: false,
          error: false,
        },
        {
          label: "Verificando configurações",
          active: false,
          success: false,
          error: false,
        },
      ],
      current: 1,
      loading: false,
      error: false,
      error_msg: "",
      params: {},
    };
  },

  props: {
    investmentId: { type: Number },
    account_id: { type: Number },
  },

  computed: {
    progressStyle() {
      return `width: ${((this.current - 1) / (this.steps.length - 1)) * 100}%`;
    },
    prevDisabled() {
      return this.current === 1;
    },
    nextDisabled() {
      return this.current === this.steps.length;
    },
  },

  mounted() {
    this.params = {
      investment_id: this.investmentId,
      account_id: this.account_id,
    };
    setTimeout(() => this.initTest(), 2000);
  },

  methods: {
    redirectHistoric() {
      this.$router.push({
        name: "Histórico",
        params: {
          id: Number(this.investmentId),
          type: "logs",
        },
      });
    },

    colorStep(value) {
      if (value.active) {
        return "bg-ontick-carbon-500 border-ontick-green-500";
      } else if (value.success) {
        return "bg-ontick-green-500 border-ontick-green-500";
      } else if (value.error) {
        return "bg-ontick-red-500 border-ontick-red-500";
      } else return "bg-ontick-carbon-500 border-ontick-carbon-500";
    },
    initTest() {
      this.$api
        .post(this.$endpoint.INVESTMENTS_CHECK, this.params)
        .then(() => {
          this.steps[0].active = false;
          this.steps[0].success = true;
          this.steps[1].active = true;

          this.next();

          setTimeout(() => this.initTest2(), 2000);
        })
        .catch((error) => {
          this.steps[0].error = true;
          this.steps[0].active = false;
          this.steps[0].success = false;
          this.error = true;
          this.error_msg = error.data.msg;
        });
    },

    initTest2() {
      this.$api
        .post(this.$endpoint.INVESTMENTS_CHECK, this.params)
        .then(() => {
          this.steps[1].active = false;
          this.steps[1].success = true;
          this.steps[2].active = true;

          this.next();

          setTimeout(() => this.initTest3(), 2000);
        })
        .catch((error) => {
          this.steps[1].error = true;
          this.steps[1].active = false;
          this.steps[1].success = false;
          this.error = true;
          this.error_msg = error.data.msg;
        });
    },

    initTest3() {
      this.$api
        .post(this.$endpoint.INVESTMENTS_CHECK, this.params)
        .then(() => {
          this.steps[1].active = false;
          this.steps[2].active = false;
          this.steps[2].success = true;
          this.next();
          setTimeout(() => {
            this.$emit("successStep", true);
          }, 1000);
        })
        .catch((error) => {
          this.steps[2].error = true;
          this.steps[2].active = false;
          this.steps[2].success = false;
          this.error = true;
          this.error_msg = error.data.msg;
        });
    },
    next() {
      this.current++;
      if (this.current > this.steps.length) {
        this.current = this.steps.length;
      }
    },
    // prev() {
    //   this.current--;
    //   if (this.current < 1) {
    //     this.current = 1;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.progress-container {
  /* margin-bottom: 30px; */
}

.progress-container::before {
  content: "";
  position: absolute;
  top: 50%;
  //   left: 0;
  transform: translateY(-50%);
  height: 3px;
  width: 100%;
  z-index: -1;
  @apply bg-ontick-carbon-500;
}

.progress {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  height: 3px;
  width: 0%;
  z-index: -1;
  transition: 0.3s ease;
  @apply bg-ontick-green-500;
}

.circle {
  transition: 0.3s ease 0.1s;
  @apply relative mt-0 flex h-8 w-8 items-center justify-center rounded-full    border-2 text-gray-300;
}

.circle.active {
  @apply border-ontick-green-500;
}
</style>
